import { useLocation, useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const location = useLocation();
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
    const href = location.pathname.startsWith('/admin') ? '/favicon-BW.svg' : '/favicon-normal.svg';
    if (favicon) {
      favicon.href = href;
      favicon.type = 'image/svg+xml';
    }
    document.title = location.pathname.startsWith('/admin') ? 'Gstore.ge POS Admin' : 'Gstore.ge POS System';
  }, [location.pathname]);

  useEffect(() => {
    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate;
      navigateResolver(window.REACT_APP_NAVIGATE);
    }
  }, [navigate]);
  return element;
}
